import React, { useCallback, useMemo, useState, memo } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQ = () => {
  const faqs = useMemo(() => [{
    id: 1,
    question: '¿Cuánto tiempo debo usarlo para sentir alivio?',
    answer: 'Generalmente, puedes comenzar a notar resultados tras 15 minutos de uso regular. Algunos usuarios sienten mejoría desde la primera aplicación. Se recomienda una rutina constante.'
  }, {
    id: 2,
    question: '¿Se puede usar en frío o caliente?',
    answer: 'Sí. Puedes usarlo de ambas formas: Frío: 10 a 15 minutos, Calor: hasta 10 minutos. Usa según tu tolerancia y lo que tu cuerpo necesite en el momento.'
  }, {
    id: 3,
    question: '¿Tiene efectos secundarios?',
    answer: 'No. No usa químicos, ni corriente, ni medicamentos. Es completamente seguro y natural.'
  }, {
    id: 4,
    question: '¿Puedo usarlo si ya estoy en tratamiento médico?',
    answer: 'Sí. Es una solución complementaria que no interfiere con ningún tratamiento. Aun así, puedes consultar con tu especialista.'
  }, {
    id: 5,
    question: '¿Sirve para otros tipos de dolor?',
    answer: 'Muchos usuarios reportan alivio en dolores cervicales, de tensión, cuello, ojos y fatiga mental.'
  }, {
    id: 6,
    question: '¿Qué garantía tengo al comprarlo?',
    answer: <>
            <p data-id="element-134">30 días para probarlo.</p>
            <p className="mt-2" data-id="element-135">
              Si no sientes un cambio… te devolvemos el dinero. Sin preguntas.
              Sin letras pequeñas.
            </p>
            <p className="mt-2" data-id="element-136">
              Porque <em data-id="element-137">creemos más en tu alivio que en una venta rápida</em>.
            </p>
          </>
  }, {
    id: 7,
    question: '¿El pago es seguro y qué métodos de pago tienen?',
    answer: <>
            <p data-id="element-138">
              Sí. Tu compra está protegida con plataformas de pago 100% seguras
              como N1CO y WOMPI si deseas pagar con tarjeta.
            </p>
            <p className="mt-2 font-medium" data-id="element-139">
              También tenemos PAGO CONTRA ENTREGA EN TODO EL SALVADOR
            </p>
            <p className="mt-2" data-id="element-140">
              Además, puedes pagar por transferencia bancaria BAC CREDOMATIC a
              cuenta jurídica a nombre de SHOPYSV. Nuestro número de cuenta es:
              201502648
            </p>
            <p className="mt-2" data-id="element-141">
              Tomas una captura de pantalla y la envías a nuestro número de
              WhatsApp: 7666-8786
            </p>
            <p className="mt-2" data-id="element-142">Correo: contacto@shopysv.com</p>
          </>
  }, {
    id: 8,
    question: '¿Tendré que pagar algo extra al recibirlo?',
    answer: <>
            <p data-id="element-143">
              No. El precio que ves publicado ya incluye el producto, accesorios
              y envío gratis.
            </p>
            <p className="mt-2" data-id="element-144">
              No tendrás cargos ocultos ni sorpresas al recibirlo.
            </p>
          </>
  }, {
    id: 9,
    question: '¿Cómo sé que no me van a estafar?',
    answer: <>
            <p data-id="element-145">
              Somos una tienda verificada online y física ubicada en Condominios
              Cuscatlán, local 203 y 216, San Salvador 🛡️
            </p>
            <p className="mt-2" data-id="element-146">
              Además, trabajamos con procesadores de pago reconocidos y
              ofrecemos envío con empresas de mensajería confiables
            </p>
            <p className="mt-2" data-id="element-147">
              Recibirás confirmación y número de rastreo al realizar tu compra.
            </p>
          </>
  }, {
    id: 10,
    question: '¿Qué beneficios tengo comprando ahora y no después?',
    answer: <>
            <p className="font-medium" data-id="element-148">✅ Al comprar ahora aseguras:</p>
            <ul className="mt-2 space-y-1 list-disc pl-5" data-id="element-149">
              <li data-id="element-150">Precio promocional activo (puede subir en próximos días).</li>
              <li data-id="element-151">Stock disponible inmediato (la demanda es muy alta).</li>
              <li data-id="element-152">
                Envío prioritario, para que lo recibas antes que otros
                compradores.
              </li>
            </ul>
          </>
  }], []);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = useCallback((index: number) => {
    setOpenIndex(prevIndex => prevIndex === index ? null : index);
  }, []);
  return <section id="faq" className="py-16 md:py-24 bg-[#f8f9ff]" data-id="element-153">
      <div className="container mx-auto px-4 md:px-6" data-id="element-154">
        <div className="max-w-3xl mx-auto" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-[#1e293b] text-center" data-id="element-156">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-6" data-id="element-157">
            {faqs.map((faq, index) => <div key={faq.id} className={`border-2 rounded-xl overflow-hidden bg-white shadow-sm transition-all duration-300 ${openIndex === index ? 'border-[#8b5cf6] shadow-md' : 'border-[#e2e8f0] hover:border-[#d1d5db]'}`} data-id="element-158">
                <button className="w-full flex justify-between items-center p-6 text-left focus:outline-none" onClick={() => toggleFaq(index)} aria-expanded={openIndex === index} aria-controls={`faq-answer-${faq.id}`} data-id="element-159">
                  <h3 className={`text-lg md:text-xl font-medium ${openIndex === index ? 'text-[#6366f1]' : 'text-[#1e293b]'}`} data-id="element-160">
                    {faq.question}
                  </h3>
                  <div className={`flex items-center justify-center w-8 h-8 rounded-full transition-colors ${openIndex === index ? 'bg-[#eef2ff]' : 'bg-[#f8fafc]'}`} data-id="element-161">
                    {openIndex === index ? <ChevronUpIcon size={18} className="text-[#6366f1]" data-id="element-162" /> : <ChevronDownIcon size={18} className="text-[#6366f1]" data-id="element-163" />}
                  </div>
                </button>
                <div id={`faq-answer-${faq.id}`} className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-[500px] pb-6' : 'max-h-0'}`} data-id="element-164">
                  <div className="text-[#4a5568] leading-relaxed" data-id="element-165">
                    {faq.answer}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default memo(FAQ);